var map = {
	"./css-3.svg": 806,
	"./git-icon.svg": 749,
	"./html-1.svg": 980,
	"./java-14.svg": 900,
	"./java.svg": 186,
	"./javascript-1.svg": 13,
	"./react-2.svg": 520,
	"./redux.svg": 691,
	"./sass-1.svg": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 816;